import ButtonsGroupPanel from "src/Components/Common/ButtonsGroupPanel";
import setCurrentPage from "src/Utils/setCurrentPage";

const PANEL_BUTTONS_DATA = [
  {
    label: "COST OBSERVALIBILITY",
    onClick: () => {
      setCurrentPage(112);
    },
    endIcon: "arrow-right",
    type: "panel-enabled" as ButtonProps["type"],
  },
  {
    label: "cost optimization",
    onClick: () => {
      setCurrentPage(113);
    },
    endIcon: "arrow-right",
    type: "panel-enabled" as ButtonProps["type"],
  },
  {
    label: "Cognitive finops",
    endIcon: "arrow-right",
    type: "panel-disabled" as ButtonProps["type"],
  },
];

export const DATA_DOW_DEMO_DNA1_10 = {
  title: "Cognitive Finops",
  subtitle: "Data Operations Workbench demo",
  text: "<b>How can I optimize? </b> Ways to reduce the cost \nof a service on a particular warehouse and \ngenerate recommendations for optimizing \nwarehouses by studying workload patterns.",
  label: { iconPath: "start.png", text: "Cost Management" },
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  next: {
    label: "END DEMO",
    onClick: () => {
      setCurrentPage(115);
    },
    type: "transparent" as "transparent",
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(111),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA1/DNA1_DOW_DEMO_Video_bg.png",
  rightSideVideo: "DNA1/DNA1_DOW_DEMO_10_video.mp4",
  pageNumber: 114,
  rightSideComponent: (
    <ButtonsGroupPanel
      title={"SELECT A FEATURE"}
      panelButtons={PANEL_BUTTONS_DATA}
      panelStyle={{ position: "absolute", bottom: "96px", right: "100px" }}
    />
  ),
};
